<template>
  <div class="comboChoose">
    <div class="choose">
      <el-collapse v-model="activeName" accordion >
        <el-collapse-item title="基本信息" name="1">
            <el-checkbox-group v-model="total_value">
              <el-checkbox label="全选" name="all" border @change="allTotal"></el-checkbox>
              <el-checkbox v-for="(item,index) in total" :key="item.name" :label="item.label" boder :name="item.name" @change="sendTotal(index)" border></el-checkbox>
            </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item title="环境信息" name="2">
          <el-checkbox-group v-model="env_value" >
            <el-checkbox label="全选" name="all" border @change="allEnv"></el-checkbox>
            <el-checkbox v-for="(item,index) in env" :key="item.name" :label="item.label" border :name="item.name" @change="sendEnv(index)" border></el-checkbox>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item title="道路信息" name="3">
          <el-checkbox-group v-model="road_value" >
            <el-checkbox label="全选" name="all" border @change="allRoad"></el-checkbox>
            <el-checkbox v-for="(item,index) in road" :key="item.name" :label="item.label" border :name="item.name" @change="sendRoad(index)" border></el-checkbox>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item title="参与方信息(车)" name="4">
          <el-checkbox-group v-model="car_value" >
            <el-checkbox label="全选" name="all" border @change="allCar"></el-checkbox>
            <el-checkbox v-for="(item,index) in car" :key="item.name" :label="item.label" border :name="item.name" @change="sendCar(index)" border></el-checkbox>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item title="参与方信息(二轮车)" name="5">
          <el-checkbox-group v-model="twoWheel_value" >
            <el-checkbox label="全选" name="all" border @change="allTwowheel"></el-checkbox>
            <el-checkbox v-for="(item,index) in twoWheel" :key="item.name" :label="item.label" border :name="item.name" @change="sendTwowheel(index)" border></el-checkbox>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item title="参与方信息(人)" name="6">
          <el-checkbox-group v-model="person_value" >
            <el-checkbox label="全选" name="all" border @change="allPerson"></el-checkbox>
            <el-checkbox v-for="(item,index) in person" :key="item.name" :label="item.label" border :name="item.name" @change="sendPerson(index)" border></el-checkbox>
          </el-checkbox-group>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="sureButton">
      <el-button type="warning" @click="reset">全部重选</el-button>
      <el-button type="primary" @click="save">确认保存</el-button>
    </div>
  </div>
</template>

<script>
    import  bus from './bus'

    export default {
      name: "comboChoose",
      data() {
        return {
          /*显示哪一部分的筛选选项*/
          activeName: '1',
          /*每一部分对应的可选值*/
          total: [
            {label: '委托号', name: 'commissionNumber'},
            {label: '参与方总数', name: 'participantsNum'},
            {label: '事故形态', name: 'accidentForm'},
            {label: '事故具体类型', name: 'accidentType'},
            {label: '障碍物类型', name: 'obstacleType'},
            {label: '天网及其他视频', name: 'otherVideo'},
            {label: '事故分类', name: 'classificationOfAccidents'},
            {label: '参与方类别', name: 'typeOfParticipants'},
            {label: '目标与主车行驶方向关系', name: 'relationshipBetweenTargetAndDirection'},
          ],
          total_value:[],
          env: [
            {label: '事故地点', name: 'accidentAddress'},
            {label: '经度', name: 'eastLongitude'},
            {label: '纬度', name: 'northLatitude'},
            {label: '路段信息', name: 'roadInformation'},
            {label: '天气', name: 'weather'},
            {label: '事故发生时段', name: 'periodOfAccident'},
            {label: '照明情况', name: 'lightingSituation'},
            {label: '日间太阳光线', name: 'lightCondition'},
            {label: '雾天能见度', name: 'visibilityInFog'},
            {label: '降雨量', name: 'precipitation'},
            {label: '降雪量', name: 'snowfall'},
            {label: '温度(℃)', name: 'temperature'},
            {label: '风速', name: 'windSpeed'},
            {label: '风级', name: 'windLevel'},
            {label: '风向', name: 'windDirection'}
          ],
          env_value:[],
          road: [
            {label: '参与方编号', name: 'participantNumber'},
            {label: '参与方所在道路名称', name: 'roadName'},
            {label: '事故地点道路走向', name: 'directionRoadAtCollisionPoint'},
            {label: '道路行政等级', name: 'administrativeRankOfRoad'},
            {label: '公路等级', name: 'classOfRoad'},
            {label: '城市道路类型', name: 'typeOfCityRoad'},
            {label: '整体机动车道数(条)', name: 'totalNumberOfMotorVehicleLanes'},
            {label: '东侧机动车道数(条)', name: 'numberVehicleLanesOnEastSide'},
            {label: '西侧机动车道数(条)', name: 'numberVehicleLanesOnWestSide'},
            {label: '南侧机动车道数(条)', name: 'numberVehicleLanesOnSouthSide'},
            {label: '北侧机动车道数(条)', name: 'numberVehicleLanesOnNorthSide'},
            {label: '非机动车道(东西)', name: 'nonMotorVehicleLaneOfEastWest'},
            {label: '非机动车道(南北)', name: 'nonMotorVehicleLaneOfSouthNorth'},
            {label: '道路横截面的轮廓', name: 'outlineOfRoadCrossSection'},
            {label: '交通标志是否被阻挡不可见', name: 'trafficSignsNotVisible'},
            {label: '路口信号灯', name: 'intersectionSignalLamp'},
            {label: '对向机动车道隔离形式', name: 'isolationFormOfOppositeVehicleLane'},
            {label: '东侧机非车道隔离形式', name: 'isolation_form_of_east_no_motor_vehicle_lane'},
            {label: '西侧机非车道隔离形式', name: 'isolation_form_of_west_no_motor_vehicle_lane'},
            {label: '南侧机非车道隔离形式', name: 'isolation_form_of_sourth_no_motor_vehicle_lane'},
            {label: '北侧机非车道隔离形式', name: 'isolation_form_of_north_no_motor_vehicle_lane'},
            {label: '道路总宽度(m)', name: 'overall_width_of_road'},
            {label: '道路的线形', name: 'the_linear_shape_of_the_road'},
            {label: '曲率半径(m)', name: 'radius_of_curve'},
            {label: '沿道路方向的趋势', name: 'trendsAlongTheRoad'},
            {label: '该趋势的坡度(%)', name: 'slope_of_the_trend'},
            {label: '最高允许车速(km/h)', name: 'maximumAllowedSpeed'},
            {label: '现场有何种交通警告标志', name: 'traffic_warning_sign'},
            {label: '现场有何种交通禁止标志', name: 'traffic_ban_sign'},
            {label: '路灯是否开启', name: 'street_lighting'},
            {label: '路灯的密度', name: 'density_of_street_lighting'},
            {label: '路面材料', name: 'type_of_road_surface'},
            {label: '道路表面污染', name: 'surface_fouling'},
            {label: '路表潮湿度', name: 'road_surface_humidity'},
            {label: '路面状况', name: 'road_condition'},
            {label: '是否有轨道', name: 'rails_in_road_surface'},
            {label: '影响视线的障碍物', name: 'view_obstacle'},
            {label: '道路状况评估', name: 'road_condition_rating'},
            {label: '是否有建筑设施', name: 'construction_facilities'},
            {label: '交通限速设施', name: 'traffic_speed_limiting_facilities'},
            {label: '车辆是否冲到相应路边', name: 'vehicles_rushed_to_corresponding_roadside'},
            {label: '东侧道路路面布局', name: 'pavement_layout_on_east_side'},
            {label: '东侧车道边缘的地面', name: 'east_side_of_driveway'},
            {label: '东侧车道边缘高度', name: 'east_side_lane_edge_height'},
            {label: '西侧道路路面布局', name: 'pavement_layout_on_west_side'},
            {label: '西侧车道边缘的地面', name: 'west_side_of_driveway'},
            {label: '西侧车道边缘高度', name: 'west_side_lane_edge_height'},
            {label: '南侧道路路面布局', name: 'pavement_layout_on_south_side'},
            {label: '南侧车道边缘的地面', name: 'south_side_of_driveway'},
            {label: '南侧车道边缘高度', name: 'south_side_lane_edge_height'},
            {label: '北侧道路路面布局', name: 'pavement_layout_on_north_side'},
            {label: '北侧车道边缘的地面', name: 'north_side_of_driveway'},
            {label: '北侧车道边缘高度', name: 'north_side_lane_edge_height'},
            {label: '车辆是否跌入水沟', name: 'vehicle_fell_into_ditch'},
            {label: '水沟深(cm)', name: 'ditch_depth'},
            {label: '所在车道的宽度(m)', name: 'width_of_lane'},
            {label: '照明', name: 'lighting'},
            {label: '是否为变宽路段', name: 'whether_it_is_a_widened_section'},
            {label: '是否有为变窄路段', name: 'whether_there_a_narrow_section'},
            {label: '是否有隧道', name: 'whether_there_a_tunnel'},
            {label: '是否为匝道口', name: 'whether_it_a_ramp'}
          ],
          road_value:[],
          car: [
            {label: '参与方编号(车)', name: 'participantNumber_car'},
            {label: '参与方类型', name: 'type_of_participant_car'},
            {label: '参与方颜色', name: 'participant_color_car'},
            {label: '长度(mm)', name: 'veh_length'},
            {label: '宽度(mm)', name: 'veh_width'},
            {label: '高度(mm)', name: 'veh_hight'},
            {label: '整备质量(kg)', name: 'weight_car'},
            {label: '前排乘客质量(kg)', name: 'occ_front'},
            {label: '后排乘客质量(kg)', name: 'occ_rear'},
            {label: '车顶载荷(kg)', name: 'roof_cargo'},
            {label: '后备箱载荷(kg)', name: 'trunk_cargo'},
            {label: '重心高度(cm)', name: 'cog_height'},
            {label: '重心到前轴的距离(mm)', name: 'cog_axle'},
            {label: '前悬(mm)', name: 'veh_frontoverhang'},
            {label: '车辆最前端的高度(cm)', name: 'veh_shape_h3'},
            {label: '轴距(mm)', name: 'wheelbase'},
            {label: '前轮距(mm)', name: 'trackwidth_1'},
            {label: '后轮距(mm)', name: 'trackwidth_2'},
            {label: '轮胎型号', name: 'tire_model'},
            {label: '胎压(bar)', name: 'tire_pressure'},
            {label: '附着系数', name: 'coeff_frict'},
            {label: 'IXX(kgm^2)', name: 'moment_roll_l'},
            {label: 'IYY(kgm^2)', name: 'moment_pitch_l'},
            {label: 'IZZ(kgm^2)', name: 'moment_yaw_l'},
            {label: '定速巡航控制', name: 'cruise_control'},
            {label: '自适应巡航ACC', name: 'adaptive_cruise_acc'},
            {label: '安全带提醒装置', name: 'seat_belt_reminder'},
            {label: '是否有主动行人保护装置', name: 'whether_there_is_active_pedestrian_protection_device'},
            {label: '助力转向类型', name: 'type_of_power_steering'},
            {label: '制动执行机构类型', name: 'type_of_brake_actuator'},
            {label: '是否有制动力分配系统', name: 'ebd_braking_force_distribution_system'},
            {label: '是否有防抱死系统', name: 'abs_anti_lock_system'},
            {label: '是否有车身稳定系统', name: 'esp_vsc_body_stabilization_system'},
            {label: '是否有牵引力控制系统', name: 'asr_tcs_trc_atc_traction_control_system'},
            {label: '是否有刹车辅助系统', name: 'eba_bas_brake_assistant_system'},
            {label: '胎压监测装置', name: 'tire_pressure_monitoring_device'},
            {label: '并线辅助/盲点监测', name: 'concurrent_auxiliary_or_blind_spot_monitoring'},
            {label: '车道偏离预警LDW', name: 'lane_departure_warning_ldw'},
            {label: '车道保持系统LKA', name: 'lane_keeping_system_lka'},
            {label: '自动紧急制动', name: 'automatic_emergency_braking'},
            {label: '预碰撞安全系统', name: 'pre_crash_safety_system_pre_collision_system'},
            {label: '驾驶员性别', name: 'driver_gender'},
            {label: '驾驶员年龄', name: 'driver_age'},
            {label: '驾驶员是否分心', name: 'is_the_driver_distracted'},
            {label: '驾驶员生理问题', name: 'driver_physiology'},
            {label: '碰撞角度', name: 'collisionAngle'},
            {label: '行驶方式', name: 'vehicle_travelled'},
            {label: '主要过错(车)', name: 'main_accident_cause_car'},
            {label: '是否有优先权', name: 'whether_there_a_priority'},
            {label: '道路方向', name: 'road_direction'},
            {label: '行车记录仪数据', name: 'vehicle_record_data'},
            {label: 'EDR数据', name: 'edr_data'},
            {label: '事故前车辆的避撞对象', name: 'object_avoid_collision_before_accident'},
            {label: '事故前车辆的避撞行为', name: 'collision_avoidance_behavior_of_front_vehicle'},
            {label: '碰撞前是否采取转向措施', name: 'whether_steering_before_collision'},
            {label: '碰撞前制动时间(s)', name: 'braking_time_before_collision'},
            {label: '碰撞前制动距离(m)', name: 'braking_distance_before_collision'},
            {label: '是否有视野盲区(外)', name: 'blind_area_outside_car'},
            {label: '是否有视野盲区(内)', name: 'blind_area_in_car'},
            {label: '第一接触点离最前部距离X', name: 'first_contact_point_from_front_x'},
            {label: '第一接触点离最前部距离Y', name: 'first_contact_point_from_front_y'},
            {label: '第一接触点离地面距离Z', name: 'first_contact_point_from_front_z'},
            {label: '车辆初始速度(km/h)', name: 'normal_driving_speed_before_vehicle_collision'},
            {label: '碰撞时速度(km/h)', name: 'collision_velocity'},
            {label: 'EES(km/h)', name: 'ees'},
            {label: 'delta_V(km/h)', name: 'delta_v'},
            {label: '行驶方向', name: 'direction_of_driving'},
            {label: '事故发生前车辆运动类型', name: 'vehicle_movement_type_before_accident'},
            {label: '碰撞前是否采取转向措施', name: 'take_steering_measures_before_collision'}
          ],
          car_value:[],
          twoWheel: [
            {label: '参与方编号(二轮车)', name: 'participant_number_twoWheel'},
            {label: '二轮车种类', name: 'typeOfParticipantTwoWheel'},
            {label: '二轮车颜色', name: 'participantColorTwoWheel'},
            {label: '长度(mm)', name: 'veh_length_two_wheel'},
            {label: '宽度(mm)', name: 'veh_width_two_wheel'},
            {label: '高度(mm)', name: 'veh_hight_two_wheel'},
            {label: '整备质量(kg)', name: 'weight_two_wheel'},
            {label: '附着系数', name: 'coeff_frict_two_wheel'},
            {label: '轴距(cm)', name: 'wheelbase_two_wheel'},
            {label: '坐垫离地高度(cm)', name: 'seat_height_from_the_ground'},
            {label: '是否为电动车', name: 'electric_vehicle_or_not'},
            {label: '主要过错(二轮车)', name: 'main_accident_cause_two_wheel'},
            {label: '二轮车运动方向', name: 'twoWheelerMovementDirection'},
            {label: '二轮车速度(km/h)', name: 'twoWheelSpeed'},
            {label: '事故时车灯是否开启', name: 'light_switched_on'},
            {label: '第一碰撞位置相对自身方位', name: 'orientation_of_first_collision_position_of_two_wheeled_vehicle'},
            {label: '年龄(二轮车)', name: 'age_two_wheel'},
            {label: '性别(二轮车)', name: 'genderTwoWheel'},
            {label: '衣着颜色(二轮车)', name: 'clothing_color'},
            {label: '是否戴头盔', name: 'wearHelmet'},
            {label: '头盔颜色', name: 'helmet_color'},
            {label: '在黑暗处或夜间衣物可见性', name: 'conspicuousness_of_clothing_in_the_dark'},
            {label: '与车辆行驶方向的关系', name: 'relation_of_driving_direction'},
            {label: '事故时转向避让反应', name: 'steering_reaction_in_accident'},
            {label: '二轮车转向灯是否开启', name: 'whether_turn_signal_of_two_wheeled_vehicle_turned'},
            {label: '是否有优先权', name: 'whether_there_a_priority'},
            {label: '碰撞前是否采取转向措施', name: 'start_reacting_take_steering_measures'},
            {label: '车辆运动类型', name: 'type_vehicle_movement_before_accident'},
            {label: '二轮车乘客数', name: 'number_passengers_on_two_wheelers'},
            {label: '二轮车载重(kg)', name: 'two_wheeled_vehicle_weight'}
          ],
          twoWheel_value:[],
          person: [
            {label: '参与方编号(人)', name: 'participant_number_person'},
            {label: '参与方类型', name: 'type_of_participant_person'},
            {label: '年龄(人)', name: 'agePerson'},
            {label: '性别(人)', name: 'genderPerson'},
            {label: '身高(人)(cm)', name: 'vehHight'},
            {label: '体重(人)(kg)', name: 'weight_person'},
            {label: '衣着颜色', name: 'participantColorPerson'},
            {label: '黑暗处或夜间衣物可见性', name: 'visibilityInTheDarkOrAtNight'},
            {label: '主要过错(人)', name: 'main_accident_cause_person'},
            {label: '事故发生地点', name: 'accidentLocation'},
            {label: '行人穿越机动车道位置', name: 'pedestrianCrossingTheMotorwayLocation'},
            {label: '行人行走方向', name: 'pedestrianWalkingDirection'},
            {label: '行人运动状态', name: 'pedestrianMovement'},
            {label: '行人速度', name: 'pedestrian_speed'},
            {label: '行人被撞部位', name: 'pedestrian_being_hit'},
            {label: '行人相对于车辆的位置', name: 'positionOfPedestrianRelativeToVehicleBeforeCollision'},
            {label: '穿越机动车道能否被看到', name: 'can_you_be_seen_when_crossing_the_motorway'},
            {label: '是否因为视野盲区造成事故', name: 'whether_it_is_caused_by_a_blind_spot_of_vision'},
            {label: '停靠车辆造成视野盲区', name: 'whetherBlindareaOfPedestrianIsCausedByParkedVehicle'},
            {label: '其他造成视线盲区的物体', name: 'areThereOtherObjectsThatCausePedestrianBlindSpots'},
            {label: '碰撞前是否有应急姿态', name: 'whether_emergency_posture_before_collision'},
            {label: '行人是否从障碍物后穿出', name: 'whether_pedestrians_wear_out_from_obstacles'},
            {label: '行人意识到危险之前加速', name: 'whether_pedestrians_before_they_accelerate'},
            {label: '行人行走方向是否改变', name: 'whether_walking_direction_pedestrian_changes'},
          ],
          person_value:[],
          /*用户选定的值*/
          final:[],
        }
      },
      methods : {
        /* 遍历用户选择的项 */
        traverse(name,code){
          for(let i = 0;i < name.length; i++){
            if(this.final.indexOf(name[i].name) > -1){
              code += '1';
            }
            else{
              code += '0';
            }
          }
          return code;
        },
        /*提交筛选项函数*/
        save(){
          let postData = {};
          let totalCode = '';
          let environmentCode = '';
          let carCode = '';
          let personCode = '';
          let twoWheelCode = '';
          let roadCode = '';
          //前四位为0 第五位为1
          totalCode = '01001' + this.traverse(this.total,totalCode) + '1';
          environmentCode = '00001' + this.traverse(this.env,environmentCode);
          carCode = '00001' + this.traverse(this.car,carCode);
          personCode = '00001' + this.traverse(this.person,personCode);
          twoWheelCode = '00001' + this.traverse(this.twoWheel,twoWheelCode);
          roadCode = '00001' + this.traverse(this.road,roadCode);
          postData['totalCode'] = totalCode;
          postData['environmentCode'] = environmentCode;
          postData['carCode'] = carCode;
          postData['personCode'] = personCode;
          postData['twoWheelCode'] = twoWheelCode;
          postData['roadCode'] = roadCode;
          bus.$emit('chooseType',postData);
        },
        /*清空筛选项函数*/
        reset(){
          this.total_value = [];
          this.env_value = [];
          this.road_value = [];
          this.car_value = [];
          this.twoWheel_value = [];
          this.person_value = [];
          this.final = [];
        },
        /* 数组的push防重复*/
        pushSingle(value,name,index){
          //先判断是否已选
          if(value.indexOf(name[index].label) > -1){
            if(this.final.indexOf(name[index].name) === -1){
              //再判断是否重复
              this.final.push(name[index].name);
            }
          }
          else{
            let index = this.final.indexOf(name[index]);
            this.final.splice(index, 1);
          }
        },
        /* 全选函数*/
        allTotal(){
          if(this.total_value.length === 1){
            this.total.forEach((item,index)=>{
              this.total_value.push(item.label);
              this.pushSingle(this.total_value,this.total,index);
            });
          }
          else{
            this.total_value = [];
            for(let i = 0;i < this.total.length;i++){
              for(let j = 0; j < this.final.length;j++){
                if(this.final[j] === this.total[i].name){
                  this.final.splice(j,1);
                }
              }
            }
          }
        },
        allEnv(){
          if(this.env_value.length === 1){
            this.env.forEach((item,index)=>{
              this.env_value.push(item.label);
              this.pushSingle(this.env_value,this.env,index);
            });
          }
          else{
            this.env_value = [];
            for(let i = 0;i < this.env.length;i++){
              for(let j = 0; j < this.final.length;j++){
                if(this.final[j] === this.env[i].name){
                  this.final.splice(j,1);
                }
              }
            }
          }
        },
        allRoad(){
          if(this.road_value.length === 1){
            this.road.forEach((item,index)=>{
              this.road_value.push(item.label);
              this.pushSingle(this.road_value,this.road,index);
            });
          }
          else{
            this.road_value = [];
            for(let i = 0;i < this.road.length;i++){
              for(let j = 0; j < this.final.length;j++){
                if(this.final[j] === this.road[i].name){
                  this.final.splice(j,1);
                }
              }
            }
          }
        },
        allCar(){
          if(this.car_value.length === 1){
            this.car.forEach((item,index)=>{
              this.car_value.push(item.label);
              this.pushSingle(this.car_value,this.car,index);
            });
          }
          else{
            this.car_value = [];
            for(let i = 0;i < this.car.length;i++){
              for(let j = 0; j < this.final.length;j++){
                if(this.final[j] === this.car[i].name){
                  this.final.splice(j,1);
                }
              }
            }
          }
        },
        allTwowheel(){
          if(this.twoWheel_value.length === 1){
            this.twoWheel.forEach((item,index)=>{
              this.twoWheel_value.push(item.label);
              this.pushSingle(this.twoWheel_value,this.twoWheel,index);
            });
          }
          else{
            this.twoWheel_value = [];
            for(let i = 0;i < this.twoWheel.length;i++){
              for(let j = 0; j < this.final.length;j++){
                if(this.final[j] === this.twoWheel[i].name){
                  this.final.splice(j,1);
                }
              }
            }
          }
        },
        allPerson(){
          if(this.person_value.length === 1){
            this.person.forEach((item,index)=>{
              this.person_value.push(item.label);
              this.pushSingle(this.person_value,this.person,index);
            });
          }
          else{
            this.person_value = [];
            for(let i = 0;i < this.person.length;i++){
              for(let j = 0; j < this.final.length;j++){
                if(this.final[j] === this.person[i].name){
                  this.final.splice(j,1);
                }
              }
            }
          }
        },
        /*选中后push对应的值进入数组*/
        sendTotal(index){
          this.pushSingle(this.total_value,this.total,index);
        },
        sendEnv(index){
          this.pushSingle(this.env_value,this.env,index);
        },
        sendRoad(index){
          this.pushSingle(this.road_value,this.road,index);
        },
        sendCar(index){
          this.pushSingle(this.car_value,this.car,index);
        },
        sendTwowheel(index){
          this.pushSingle(this.twoWheel_value,this.twoWheel,index);
        },
        sendPerson(index){
          this.pushSingle(this.person_value,this.person,index);
        }
      }
    }
</script>

<style scoped>
  .comboChoose{
    width: 100%;
    height: 100%;
  }
  .choose{
    margin-left: 2%;
    width: 98%;
    height: 90%;
    overflow-y: scroll;
  }
  .sureButton{
    margin-left: 70%;
    width: 20%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .el-checkbox-group{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .el-checkbox{
    width: 200px;
    margin-top: 10px;
  }
</style>

<style>
  .comboChoose .el-checkbox{
    margin-left: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/exportData/comboChoose.vue